import { ButtonPrimary } from '@modules/common/components/form/buttons/button-primary';
import { useFormikContext } from 'formik';
import { handleGiftCardTypeSelection } from '../handles/handle-giftcard-type-selection';
import { CARD_PROGRAMS } from '@lib/constants';
import React, { useEffect, useState } from 'react';
import letThemChooseUtil from '@lib/util/let-them-choose-util';
import { useAvailableCyoThemeCards } from '@lib/hooks/use-availableCyoThemeCards';
import { useStoreClosed } from '@lib/context/store-closed-context';

export const GiftCardTypes = () => {
  const storeClosed = useStoreClosed();
  const [description, setDescription] = useState('');
  const form = useFormikContext<any>();
  const field = form.getFieldProps('giftCardType');
  const [giftCardTypes, setGiftCardTypes] = useState<string[]>([]);
  const { giftCardTypesText, configurationPageDescriptions } = useAvailableCyoThemeCards();
  const [loading, setLoading] = React.useState(true);

  const handleSelectionChange = (item: string) => {
    sessionStorage.setItem(CARD_PROGRAMS.KEY, item);
    setDescription(letThemChooseUtil.getDescription(item, configurationPageDescriptions));
  };

  useEffect(() => {
    const getGiftCardTypes = async () => {
      const response = await letThemChooseUtil.getGiftCardTypes(storeClosed?.availableCyoThemeCards);
      setGiftCardTypes(response);
      handleGiftCardTypeSelection({ item: response?.[0], field, form });
    };
    setTimeout(() => {
      let cardProgram = sessionStorage.getItem(CARD_PROGRAMS.KEY) ?? CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;
      if (cardProgram) {
        cardProgram = storeClosed?.availableCyoThemeCards?.[0]?.key;
        handleSelectionChange(cardProgram);
      }
      setDescription(letThemChooseUtil.getDescription(cardProgram, configurationPageDescriptions));
      getGiftCardTypes();
    }, 1000);
  }, [storeClosed?.availableCyoThemeCards, configurationPageDescriptions]);

  useEffect(() => {
    if (description && configurationPageDescriptions) {
      setLoading(false);
    }
  }, [description, configurationPageDescriptions]);

  return (
    loading ? <div className="h-30 p-3 space-y-3">
                <div className="h-5 bg-gray-300 animate-pulse rounded-lg" />
                <div className="h-5 bg-gray-300 animate-pulse rounded-lg" />
                <div className="h-5 bg-gray-300 animate-pulse rounded-lg" />
              </div>
      :
    <div>
      {description && configurationPageDescriptions && (<div>
        The perfect gift when you're not quite sure what to give! With a Choose Your Own gift card, you set the amount
        and your recipient can select from{' '}
        {description != configurationPageDescriptions?.choose_your_own_restaurant && 'over'} <b>{description}</b>. Your
        gift, their choice.
      </div>)}
      <div className="text-base text-black font-medium mb-2">Type:</div>
      <div className="card__method__items gap-1.5 flex flex-row flex-wrap">
        {giftCardTypes.map((item, _index) => (
          <div key={item}>
            <ButtonPrimary
              type="button"
              size="medium"
              active={field.value === item}
              onClick={() => {
                handleGiftCardTypeSelection({ item, field, form });
                handleSelectionChange(item);
              }}
              className="!py-1 hasGraybtn"
            >
              {giftCardTypesText?.[item] as string}
            </ButtonPrimary>
          </div>
        ))}
      </div>
    </div>
  );
};
